<template>
  <div class="toggle" :class="icon" @click.prevent="handleClick">
    <app-icon class="icon" :icon="modelValue ? 'toggleOn' : 'toggleOff'" :size="size"></app-icon>
    <slot></slot>
  </div>
</template>

<script>
export default {
  emits: ['update:modelValue', 'toggle'],

  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    size: {
      type: String,
      required: false,
      default: "lg"
    }
  },
  computed: {
    icon() {
      if (this.modelValue) {
        return "on";
      } else {
        return "off";
      }
    },
  },
  methods: {
    handleClick() {
      this.$emit('toggle');
      this.$emit("update:modelValue", !this.modelValue);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~App/styles/variables";
  .toggle {
    text-decoration: none;
    cursor: pointer;
  }

  .toggle.on .icon {
    color: $green;
  }

  .toggle.off .icon {
    color: $grey-darker;
  }

</style>
